/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import { action } from "@ember/object";
import CrudJournalEventBaseComponent from "parog-web/components/forc/abstract/crud-journal-event-based-component";
import journalEventRetrievalStrategies from "parog-web/components/forc/utils/journal-event-retrieval-strategies";
import MrcReplacementJournalEvent from "parog-web/models/mrc-replacement-journal-event";

export default class MrcReplacementEditionFormComponent extends CrudJournalEventBaseComponent<MrcReplacementJournalEvent> {
  static forcDisplayName = "Préparation au traitement de suppléance rénale";
  static fullComponentId = "replacement/edition-form";

  static journalEventClass = MrcReplacementJournalEvent;
  retrieveJournalEvent = journalEventRetrievalStrategies.sourceJournalEvent;

  plannedReplacementTherapy = [
    "hemodialysis-in-hospital-center",
    "hemodialysis-in-a-medicalized-dialysis-unit",
    "hemodialysis-in-a-self-dialysis-unit",
    "hemodialysis-at-home",
    "continuous-ambulatory-peritoneal-dialysis",
    "automated-peritoneal-dialysis",
    "conservative-treatment",
    "not-yet-defined"
  ];

  chosenHemodialysisType = [
    "hemodialysis-in-hospital-center",
    "hemodialysis-in-a-medicalized-dialysis-unit",
    "hemodialysis-in-a-self-dialysis-unit",
    "hemodialysis-at-home"
  ];

  typeOfPeritonealDialysis = [
    "continuous-ambulatory-peritoneal-dialysis",
    "automated-peritoneal-dialysis"
  ];

  smoking = ["active-smoker", "non-smoker", "former-smoker", "unknown"];

  smokingCessation = ["not-planned", "planned", "in-progress"];

  plannedVascularAccess = [
    "arteriovenous-fistula",
    "central-vein-catheter-tunneled-catheter",
    "graft",
    "unknown"
  ];

  @action
  updateDialysisTypes() {
    const dialysisType = this.changeset.get("plannedReplacementTherapy");

    if (dialysisType === "not-yet-defined") {
      this.changeset.set("chosenHemodialysisType", null);
      this.changeset.set("typeOfPeritonealDialysis", null);
    }

    if (this.chosenHemodialysisType.includes(dialysisType)) {
      this.changeset.set("chosenHemodialysisType", dialysisType);
      this.changeset.set("typeOfPeritonealDialysis", null);
    } else if (this.typeOfPeritonealDialysis.includes(dialysisType)) {
      this.changeset.set("typeOfPeritonealDialysis", dialysisType);
      this.changeset.set("chosenHemodialysisType", null);
    }
  }

  @action
  updateChosenHemodialysis() {
    const chosenHemodialysis = this.changeset.get("chosenHemodialysisType");

    this.changeset.set("plannedReplacementTherapy", chosenHemodialysis);
    this.changeset.set("typeOfPeritonealDialysis", null);
  }

  @action
  updatePeritonealDialysis() {
    const peritonealDialysis = this.changeset.get("typeOfPeritonealDialysis");

    this.changeset.set("plannedReplacementTherapy", peritonealDialysis);
    this.changeset.set("chosenHemodialysisType", null);
  }
}
